<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="单据信息" name="first">
          <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
            <div class="edit-card">
              <div style="width: 88%; display: flex">
                <div class="start-label" />
                <span class="text">基础信息</span>
              </div>
              <el-row>
                <el-col :span="4" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="no" v-if="getIsView()" label="验收单号">
                    <el-input disabled v-model="form.no"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 验收单号:{{ form.no }}</span>
                </el-col>
                <!-- <el-col :span="6">
                  <el-form-item label="创建时间" prop="createdTime">
                    <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="createdUserName" label="发起人">
                    <el-input disabled v-model="form.createdUserName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="ownerDeptName" label="所属科室">
                    <el-input disabled v-model="form.ownerDeptName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row> -->
                <el-col :span="4" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="orderNo" v-if="getIsView()" label="采购订单">
                    <!-- <el-select v-model="form.orderNo" :disabled="!editMode" filterable :filter-method="getOrderList" @change="orderChange" style="width: 100%">
                      <el-option key="0" label="请选择订单" value></el-option>
                      <el-option v-for="item in orderList" :key="item.id" :label="item.no+' '+ item.supplierName" :value="item.no"></el-option>
                    </el-select> -->
                    <SelectTable :disabled="!editMode" :columns="orderColumns" :placeholder="'按单号或供应商搜索订单'" :innerName="form.orderNo" :dataList="orderList" @filterMethod="getOrderList" @change="orderChange" />
                  </el-form-item>
                  <span class="viewText" v-else> 采购订单:{{ form.orderNo }}</span>
                </el-col>
                <el-col :span="4" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="supplierName" v-if="getIsView()" label="供应商">
                    <el-select v-model="form.supplierName" disabled placeholder="请选择" filterable :filter-method="(value) => getSuppliers(value, 1)" @change="supplierChange" style="width: 100%">
                      <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <span class="viewText" v-else> 供应商:{{ form.supplierName }}</span>
                </el-col>
                <el-col :span="4" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="deliveryTime" v-if="getIsView()" label="送货日期">
                    <el-date-picker :disabled="!editMode" v-model="form.deliveryTime" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="送货日期" style="width: 100%"></el-date-picker>
                  </el-form-item>
                  <span class="viewText" v-else> 送货日期:{{ form.deliveryTime }}</span>
                </el-col>
                <el-col :span="4" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="warehouseName" v-if="getIsView()" label="存放库房">
                    <el-select v-model="form.warehouseName" :disabled="!approveDisable" placeholder="请选择存放库房" filterable :filter-method="getWarehouseList" @change="warehouseChange" style="width: 100%">
                      <el-option v-for="item in warehouseList" :key="item.id + ';' + item.deptIds" :label="item.name + ' ' + item.deptNames" :value="item.id + ';' + item.deptIds"></el-option>
                    </el-select>
                  </el-form-item>
                  <span class="viewText" v-else> 存放库房:{{ form.warehouseName }}</span>
                </el-col>

                <el-col :span="4" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="oneLevelWarehouseId" v-if="getIsView()" label="收货库房">
                    <el-select v-model="form.oneLevelWarehouseName" :disabled="!editMode && !approveDisable" placeholder="请选择收货库房" style="width: 100%" filterable :filter-method="getOneLevelWarehousesBySessionWarehouseId" @change="oneLevelWarehouseChange">
                      <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <span class="viewText" v-else> 收货库房:{{ form.oneLevelWarehouseName }}</span>
                </el-col>
                <el-col :span="2" :class="!getIsView()?'viewCol':''">
                  <el-form-item  v-if="form.showIsMergedOrder && getIsView()" label="中转分发">
                    <el-checkbox  :disabled="!editMode && !approveDisable" :true-label="1" :false-label="0" v-model="form.distribute" @change="$forceUpdate();"></el-checkbox>
                  </el-form-item>
                  <span class="viewText"  v-if="form.showIsMergedOrder && !getIsView()">中转分发:{{ form.distribute }}</span>
                </el-col>
              <!-- </el-row>

              <el-row> -->
                <el-col :span="4" :class="!getIsView()?'viewCol':''">
                  <el-form-item  v-if="getIsView()" prop="logistics" label="物流信息">
                    <el-input :disabled="!editMode" placeholder="请输入物流信息" v-model="form.logistics" type="text"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 物流信息:{{ form.logistics }}</span>
                </el-col>
                <el-col :span="4" :class="!getIsView()?'viewCol':''">
                  <el-form-item  v-if="getIsView()" prop="distributionStatusName" label="配送状态">
                    <el-input disabled v-model="form.distributionStatusName"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 配送状态:{{ form.distributionStatusName }}</span>
                </el-col>
                <el-col :span="4" :class="!getIsView()?'viewCol':''">
                  <el-form-item  v-if="getIsView()" prop="totalNumber" label="总数量">
                    <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 总数量:{{ form.totalNumber }}</span>
                </el-col>
                <el-col :span="4" :class="!getIsView()?'viewCol':''">
                  <el-form-item  v-if="getIsView()" prop="totalAmount" label="配送总金额">
                    <el-input disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 配送总金额:{{ form.totalAmount }}</span>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item label="备注" v-if="getIsView()" prop="remark">
                    <el-input :disabled="!approveDisable" placeholder="备注" v-model="form.remark"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 备注:{{ form.remark }}</span>
                </el-col>
              </el-row>
              <el-row> 
                 <el-col :span="4" :class="!getIsView()?'viewCol':''">
                    <el-form-item v-if="system_setting.IsUsePDA && getIsView()" prop="shelfState" label="上架状态">
                    <el-select v-model="form.shelfState" disabled placeholder="请选择"  style="width: 100%">
                      <el-option v-for="item in ShelfStateOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <span class="viewText" v-if="system_setting.IsUsePDA && !getIsView()"> 上架状态:{{ ShelfStateOptions.find(item => item.id == form.shelfState)?.name }}</span>
                 </el-col>
                <el-col :span="12">
                <el-form-item label="" prop="fileInfos">
                  <UploadFileList label="上传附件" :fileList="form.fileInfos ? form.fileInfos : []" btnShowType="always" :multipleFile="false" :showFileList="true" :editMode="editMode" @fileChange="filesChange"></UploadFileList>
                </el-form-item>
              </el-col>
            </el-row>
              
              <el-row style="margin-top: 20px"></el-row>
            </div>

            <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
              <div style="width: 88%; display: flex">
                <div class="start-label" />
                <span class="text">验收明细</span>
              </div>

              <div v-if="editMode" style="margin: 20px 0 12px 10px">
                <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
                <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
                <el-button class="btn default" size="small" v-preventReClick @click="openScanner">点击开始扫描</el-button>
              
              </div>
              <div v-else style="margin: 20px 0 12px 10px">
                <el-button class="btn default" size="small" v-if="form.distributionStatus != 2" v-preventReClick @click="packCodeEvt">动态打包</el-button>
                <el-button class="btn primary" size="small" type="primary" v-preventReClick @click="acceptEvt">一键验收</el-button>
              </div>

             

              <el-table ref="childTable" border :data="form.details" max-height="600" style="width: auto; margin: 0 10px; " @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }"
             >
                <el-table-column type="index" width="50" fixed> </el-table-column>
                <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
                <el-table-column show-overflow-tooltip prop="productName" label="产品" width="120" fixed>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="specName" label="产品规格" width="120" fixed></el-table-column>
                <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
                <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="120"></el-table-column>
                  <el-table-column v-if="system_setting.IsUsePDA" prop="shelvedNumber" label="上架数量" width="80">
                    <template slot-scope="scope">
                      {{ scope.row.shelvedNumber?scope.row.shelvedNumber:'-' }}
                    </template>
                  </el-table-column>
                <el-table-column prop="distributionNumber" label="配送数量" width="90" />
                <el-table-column prop="number" label="验收数量" width="90" />
                <el-table-column prop="inStockNumber" label="入库数量" width="90" />
                <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
                <el-table-column prop="unit" label="包装单位" width="80"></el-table-column>
                <el-table-column prop="price" label="采购价" width="80"></el-table-column>
                <el-table-column prop="amount" label="小计" width="90"></el-table-column>
                <el-table-column prop="packSpec" label="包装规格" width="100">
                </el-table-column>
                <el-table-column prop="batch" label="批次号" width="120">
                </el-table-column>
                <el-table-column prop="validityDate" label="有效期" width="120">
                  <template slot-scope="scope">
                    {{
                      scope.row.validityDate
                        ? parseTime(
                          new Date(scope.row.validityDate),
                          "{y}-{m}-{d}"
                        )
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="longTime" label="长期" width="60">
                  <template slot-scope="scope">
                    {{ scope.row.longTime == 1 ? "是" : "否" }}
                  </template>
                </el-table-column>
                <el-table-column prop="manufactureDate" label="生产日期" width="120">
                  <template slot-scope="scope">
                    {{
                      scope.row.manufactureDate
                        ? parseTime(
                          new Date(scope.row.manufactureDate),
                          "{y}-{m}-{d}"
                        )
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="disinfectDate" label="灭菌日期" width="120">
                  <template slot-scope="scope">
                    {{
                      scope.row.disinfectDate
                        ? parseTime(
                          new Date(scope.row.disinfectDate),
                          "{y}-{m}-{d}"
                        )
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="disinfectBatch" label="灭菌批号" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="serialNo" label="序列号" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="mainNo" label="主条码" width="180"></el-table-column>
                <el-table-column show-overflow-tooltip prop="traceNo" label="追溯码" width="180"></el-table-column>
                <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证" width="180"></el-table-column>
                <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号" width="180"></el-table-column>
                <el-table-column show-overflow-tooltip prop="newProductId" label="产品ID" width="150" />
                <el-table-column show-overflow-tooltip prop="productCode" label="商品代码" width="150" />
                <el-table-column show-overflow-tooltip prop="medicalInsuranceCategoryNo" label="医保代码" width="150" />
                 <el-table-column v-if="system_setting.isShowSecondSupplier" prop="secondSupplierName" show-overflow-tooltip
                  width="140" label="二级供应商">
                  <template slot-scope="scope">
                    {{ scope.row.secondSupplierName?scope.row.secondSupplierName:'-' }}
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200"></el-table-column>
                <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="newOnlineNo" label="新挂网号" width="150" />
                <el-table-column fixed="right"  v-if="$route.query.formMode==3||$route.query.formMode==0" label="重新配送" width="100">
                  <template slot-scope="scope">
                    <!-- @change="(res)=>reDeliveryChange(res,scope.row)" -->
                    <el-switch
                      v-model="scope.row.reDelivery" :disabled="$route.query.formMode==0" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0" >
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="edit-card" v-if="form.batchDistributionStatus==1 &&form.isMergedOrder==1">
               <div style="width: 88%; display: flex">
                <div class="start-label" />
                  <span class="text">科室分发明细</span>
                </div>
                <el-tabs v-model="activeName1" >
                  <el-tab-pane  v-for="(item,index) in form.purchaseDistributionBatchDetailListViewModels
                  " :key="item.index" :label="item.deptName" :name="index.toString()">
                        <el-table ref="childTable" border :data="item.distributionList" max-height="600" style="width: auto; margin:10px; " stripe  :header-cell-style="{ background: '#DDEBFF' }" 
                        > 
                      <el-table-column prop="supplierProductNo" label="供应商产品编码" min-width="180"></el-table-column>
                      <el-table-column prop="productName" label="供应商产品名称" min-width="180" />
                      <el-table-column show-overflow-tooltip prop="specName" label="产品规格" min-width="120" ></el-table-column>
                      <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" min-width="120"></el-table-column>
                      <el-table-column show-overflow-tooltip prop="demandNumber" label="需求数量" min-width="150" />
                      <el-table-column show-overflow-tooltip prop="distributionNumber" label="分发数量" min-width="150">
                      </el-table-column>
                      <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
                      <el-table-column prop="packSpec" label="包装规格" min-width="100">
                      </el-table-column>
                      <el-table-column prop="batch" label="批次号" min-width="100">
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                </el-tabs>
              </div>
            <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
          </el-form>
          <UpdatePrice ref="updatePrice" :show="updatePriceDisable" :id="form.id" :type="0" :details="form.productPriceDiffDetails" @close="updatePriceClose" @submit="updatePriceSubmit"></UpdatePrice>

          <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
            <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
              <el-row v-if="isScan">
                <el-col :span="24">
                  <el-form-item label="扫码框">
                    <el-input placeholder="请扫码" ref="no" @change="(val) => {
                      mainNoChange(val, '1');
                    }
                      " v-model="childForm.no" @focus="scanInputFocus" @blur="scanInputBlur"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item prop="mainNo" label="主条码">
                    <el-input disabled placeholder="请输入主条码" v-model="childForm.mainNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="traceNo" label="追溯码">
                    <el-input disabled placeholder="请输入追溯码" v-model="childForm.traceNo"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item prop="supplierProductNo" label="供应商产品编码">
                    <el-input disabled v-model="childForm.supplierProductNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="productName" label="产品">
                    <el-input v-if="isScan" disabled v-model="childForm.productName"></el-input>
                    <SelectTable v-if="!isScan" :disabled="!editMode" :columns="supplierProductColumns" :placeholder="'请选择产品'" :innerName="childForm.productName" :dataList="STATIC_SupplierProducts" @filterMethod="getProductList" @change="productChange" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="specName" label="产品规格">
                    <el-input disabled v-model="childForm.specName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="productRegistCertId" label="产品注册证">
                    <el-select :disabled="!editMode" placeholder="请选择注册证" v-model="childForm.productRegistCertName" filterable @change="certChange" style="width: 100%">
                      <el-option v-for="item in STATIC_ProductRegistCertDetails" :key="item.productRegistCertId" :label="item.name + ' ' + item.no" :value="item.productRegistCertId"></el-option>
                    </el-select>
                    <!-- <el-input disabled v-model="childForm.productRegistCertName"></el-input> -->
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="productRegistCertNo" label="注册证号">
                    <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="manufacturerName" label="生产厂家">
                    <el-input disabled v-model="childForm.manufacturerName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="packSpec" label="包装规格">
                    <el-input :disabled="!editMode" placeholder="请输入包装规格" v-model="childForm.packSpec"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="brand" label="品牌">
                    <el-input disabled v-model="childForm.brand"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item prop="onlineNo" label="挂网号">
                    <el-input disabled v-model="childForm.onlineNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="minUnit" label="最小单位">
                    <el-input disabled v-model="childForm.minUnit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="unit" label="包装单位">
                    <el-input disabled v-model="childForm.unit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="disinfectDate" label="灭菌日期">
                    <el-date-picker :disabled="!editMode" v-model="childForm.disinfectDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item prop="disinfectBatch" label="灭菌批号">
                    <el-input :disabled="!editMode" placeholder="请输入灭菌批号" v-model="childForm.disinfectBatch"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="manufactureDate" label="生产日期">
                    <el-date-picker :disabled="!editMode" v-model="childForm.manufactureDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%" placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="validityDate" label="有效期">
                    <el-date-picker :disabled="!editMode || Boolean(childForm.longTime)" v-model="childForm.validityDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%" placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item prop="longTime" label="长期">
                    <el-switch v-model="childForm.longTime" :disabled="!editMode" @change="longTimeChange(childForm)" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="serialNo" label="序列号">
                    <el-input :disabled="!editMode" placeholder="请输入序列号" v-model="childForm.serialNo"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item prop="batch" label="批次号">
                    <el-input :disabled="!editMode" placeholder="请输入批次号" v-model="childForm.batch"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="distributionNumber" label="配送数量">
                    <el-input disabled type="number" v-model="childForm.distributionNumber"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item prop="number" label="验收数量">
                    <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number" :controls="false" placeholder="请填写数量" @change="autoAmount" style="width: 100%"></el-input-number>
                    <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="autoAmount"></el-input> -->
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item prop="price" label="采购价">
                    <el-input :disabled="!editMode" @input="autoAmount" v-model="childForm.price"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item prop="amount" label="小计">
                    <el-input disabled v-model="childForm.amount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="newProductId" label="产品ID">
                    <el-input disabled v-model="childForm.newProductId"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="productCode" label="商品代码">
                    <el-input disabled v-model="childForm.productCode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="newOnlineNo" label="新挂网号">
                    <el-input disabled v-model="childForm.newOnlineNo"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                    <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <el-form-item prop="remark" label="备注">
                    <el-input :disabled="!editMode" placeholder="请输入备注" v-model="childForm.remark"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="">
              <el-button v-if="!isScan && editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
              <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>

              <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确
                定</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="修改记录" name="second">
          <el-table ref="childTable" border :data="form.productPriceUpdateLogs" style="width: auto; margin: 10px 0px" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" min-width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productName" label="产品名称" min-width="150"></el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" label="规格型号" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" min-width="150"></el-table-column>
            <el-table-column prop="batch" show-overflow-tooltip label="批次号" min-width="120"></el-table-column>
            <el-table-column prop="serialNo" show-overflow-tooltip label="序列号" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productCode" label="商品代码" min-width="100" />
            <el-table-column show-overflow-tooltip prop="newProductId" label="产品ID" min-width="100" />
            <el-table-column show-overflow-tooltip prop="createdUserName" label="修改人" min-width="100" />
            <el-table-column label="修改时间" min-width="180">
              <template slot-scope="scope">{{
                parseTime(new Date(scope.row.createdTime))
                }}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="content" label="修改内容" min-width="100" />
        
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-loading="loading" v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
        定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
    
    <LabelPackDialog  v-if="labelPackVisible" :open="labelPackVisible" 
    @close="closeLabelPackDialog"
    :toBePackagedData="toBePackagedData"
    :packagedData="packagedData"
    @getTableData="getTableData"
    />

    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>

    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import InNewScan from "@/mixin/inNewScan-mixin";
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  GetPurchaseDistributionById,
  SavePurchaseDistribution,
  RejectPurchaseDistribution,
  GetPurchaseOrders,
  GetDeptWarehouses,
  GetSupplierProducts,
  ValidateSupplierProducts,
  GetTagCodeDetailsByTableNoAndDetailId,
  GetProducts,
  GetUnPackedTagCodeDetailsInPurchaseDistribution,
  GetPackedTagCodeDetailsInPurchaseDistribution,
  
} from "@/api";
import { InStockOptions, WhetherOptions, AssetSourceOptions, ShelfStateOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import UpdatePrice from "@/components/update-price";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import LabelPackDialog from "@/components/labelPack-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
import UploadFileList from "@/components/upload-file-list";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, InNewScan,tagCodeMixin],
  components: {
    SelectTable,
    ApproveInfo,
    UpdatePrice,
    LabelDetailsDialog,
    LabelPackDialog,
    PackageLabelDialog,
    UploadFileList
  },
  // 
  data () {
    return {
      form: {},
      InStockOptions: InStockOptions,
      WhetherOptions: WhetherOptions,
      AssetSourceOptions: AssetSourceOptions,
      ShelfStateOptions:ShelfStateOptions,
      toBePackagedApi:GetUnPackedTagCodeDetailsInPurchaseDistribution,
      packagedApi:GetPackedTagCodeDetailsInPurchaseDistribution,
      rules: {
        deliveryTime: [
          {
            required: true,
            message: "请选择送达日期",
            trigger: "blur",
          },
        ],
        supplierName: [
          {
            required: true,
            message: "请选择供应商",
            trigger: "blur",
          },
        ],
        orderNo: [
          {
            required: true,
            message: "请选择采购订单",
            trigger: "blur",
          },
        ],
        oneLevelWarehouseId: [
          {
            required: true,
            message: "请选择收货库房",
            trigger: "blur",
          },
        ],
      },
      childFormRules: {
        productName: [
          {
            required: true,
            message: "请选择产品",
            trigger: "blur",
          },
        ],
        manufactureDate: [
          // { required: true, message: "请选择生产日期", trigger: "blur" },
          {
            validator: this.validateManufacturerDate,
            trigger: "blur",
          },
          {
            validator: this.validateDateRange,
            trigger: "blur",
          },
        ],
        validityDate: [
          // { required: true, message: "请选择有效期", trigger: "blur" },
          {
            validator: this.validateValidityDate,
            trigger: "blur",
          },
          {
            validator: this.validateDateRange,
            trigger: "blur",
          },
        ],
        // batch: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        // productRegistCertId: [
        //   {
        //     required: true,
        //     message: "请选择产品注册证",
        //     trigger: "blur",
        //   },
        // ],
        packSpec: [
          {
            required: true,
            message: "请输入包装规格",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入采购价",
            trigger: "blur",
          },
        ],
        number: [
          {
            required: true,
            message: "数量不能为空",
            trigger: "blur",
          },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
          // { validator: this.validateCheckNumber, trigger: 'blur' },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      reject: RejectPurchaseDistribution,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      approveDisable: false,
      isScan: false,
      warehouseList: [],
      orderList: [],

      updatePriceDisable: false,
      activeName: "first",
      activeName1:'0',
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getSuppliers("", 1);
    this.getWarehouseList("");
    this.getOrderList("");
    this.getOneLevelWarehousesBySessionWarehouseId("");
  },
  methods: {

    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
      this.approveDisable = true;
      this.form.showIsMergedOrder = false
       this.form.distribute = 1
    },
    // 编辑
    handleUpdate (id) {
      return new Promise((resolve, reject) => {
        GetPurchaseDistributionById({
          id,
        }).then((res) => {
          // this.resetForm()
          this.form = res.returnData;
          this.getLocations(this.form.warehouseId);
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });
          
          this.form.showIsMergedOrder = Boolean(this.form.isMergedOrder)
          if(this.$route.query.formMode==3){
            this.form.distribute =   this.form.showIsMergedOrder?1:0
          }else{
            this.form.distribute =this.form.batchDistributionStatus
          }
          this.initWorkFlowProperty(this.form);

          if (
            this.formMode == 3 &&
            this.form.status == 1 &&
            this.form.approverIds &&
            this.form.approverIds.indexOf(this.userInfo.id + "") != -1
          ) {
            this.approveDisable = true;
          }

          resolve(this.form);

          // 编辑时 触发产品选择框
          this.form.orderId = this.form.purchaseOrderId;
          this.form.supplierId = this.form.supplierId;
          this.getProductList("");
        });
      });
    },
    // 保存
    submit (showUpdatePrice) {
      this.$store.dispatch('SetLoading', true);

      const isValid = this.validateForm();
      if (!isValid) return;

      const { supplierProductIds, productIds } = this.checkProductIds();
      if (!supplierProductIds || !productIds) return;

      if (this.shouldDisableUpdatePrice(showUpdatePrice)) return;

      // 近效期校验
      const productPeriodValidate = this.checkPeriodDayValidate(this.form.details);
      const proceed = () => {
        if (this.system_setting.IsComparedWarn === 1) {
          this.handleCodeComparison();
        } else {
          this.proceedValidation(supplierProductIds);
        }
      };

      if (!productPeriodValidate.flag) {
        const content = [this.$createElement("p", `${productPeriodValidate.msg}`, { style: "color:red" }, `是否继续验收？`)];
        this.showConfirmationDialog(content, proceed);
      } else {
        proceed();
      }
    },

    validateForm() {
      let isValid = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading', false);
          isValid = false;
        }
      });
      if (!isValid) return false;

      const valdateResult = this.productDetailRepeatValidate(this.form.details);
      if (!valdateResult.flag) {
        this.$my_message(valdateResult.msg, "warning");
        this.$store.dispatch('SetLoading', false);
        return false;
      }

      if (!this.form.details || this.form.details.length === 0) {
        this.$my_message("明细表不能为空", "warning");
        this.$store.dispatch('SetLoading', false);
        return false;
      }

      return true;
    },

    checkProductIds() {
      const supplierProductIds = this.form.details.map((e) => e.supplierProductId);
      const productIds = this.form.details.map((e) => e.productId);

      if (!supplierProductIds || supplierProductIds.length === 0) {
        this.$my_message("存在没有供应商产品的明细表", "warning");
        this.$store.dispatch('SetLoading', false);
        return false;
      }

      return { supplierProductIds, productIds };
    },

    shouldDisableUpdatePrice(showUpdatePrice) {
      if (
        !showUpdatePrice &&
        this.form.productPriceDiffDetails &&
        this.form.productPriceDiffDetails.length > 0
      ) {
        this.updatePriceDisable = true;
        this.$store.dispatch('SetLoading', false);
        return true;
      }
      return false;
    },

    handleCodeComparison() {
      const { productIds, supplierProductIds } = this.checkProductIds();
      GetProducts({ ids: productIds })
        .then((res) => {
          if (res.successful) {
            const { confirm, content } = this.checkUncomparedProducts(res.returnData.data);
            if (confirm) {
              this.showConfirmationDialog(content, () => this.proceedValidation(supplierProductIds));
            } else {
              this.proceedValidation(supplierProductIds);
            }
          }
        });
    },

    checkUncomparedProducts(products) {
      let confirm = false;
      let content = [];
      const arr = [];

      products.forEach((item) => {
        if (item.isCompared === 0) {
          confirm = true;
          this.form.details.forEach((detail, index) => {
            if (detail.productId === item.id) {
              detail.INDEX = index;
              arr.push(detail);
            }
          });
        }
      });

      const uniqueProducts = [...new Set(arr.map(item => item.productId))].map(id => arr.find(item => item.productId === id))
        .sort((a, b) => a.INDEX - b.INDEX);

      uniqueProducts.forEach((j) => {
        content.push(this.$createElement("p", `第${j.INDEX + 1}行：产品名称[${j.productName}]，未对码`));
      });

      return { confirm, content };
    },

    showConfirmationDialog(content, callback) {
      this.$confirm("提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        customClass: "promptBox",
        message: this.$createElement("div", content),
        type: "warning",
      }).then(callback).catch(() => this.$store.dispatch('SetLoading', false));
    },

    proceedValidation(supplierProductIds) {
      ValidateSupplierProducts({ ids: supplierProductIds })
        .then((res) => {
          if (res.returnData && res.returnData.length > 0) {
            const { content, msg } = this.handleValidationErrors(res.returnData);
            this.showAlertDialog(content, msg);
            throw new Error(msg);
          }
        })
        .then(() => GetSupplierProducts({ ids: supplierProductIds, pageIndex: 1, pageSize: 999 }))
        .catch(() => this.$store.dispatch('SetLoading', false))
        .then((res) => {
          const { msg, flag, content } = this.checkDisabledAndPrice(res.returnData.data);
          if (msg) {
            this.$my_message(msg, "warning");
            throw new Error(msg);
          }
          if (flag) {
            this.showPriceConfirmationDialog(content);
          } else {
            this.save();
          }
        });
    },

    handleValidationErrors(errors) {
      let msg = "";
      let content = [];
      errors.forEach((item) => {
        this.form.details.forEach((detail, index) => {
          if (detail.supplierProductId === item.key) {
            content.push(this.$createElement("p", `第${index + 1}行：产品名称[${detail.productName}]，规格型号[${detail.specName}]${item.errorMessage}`));
            msg += `第${index + 1}行：产品名称[${detail.productName}]，规格型号[${detail.specName}]${item.errorMessage},`;
          }
        });
      });
      content.push(this.$createElement("p", `审核通过才能验收。`));
      msg += "审核通过才能验收。";
      return { content, msg };
    },

    showAlertDialog(content, msg) {
      this.$confirm("提示", {
        title: "提示",
        type: "warning",
        customClass: "promptBox",
        showCancelButton: false,
        showConfirmButton: true,
        message: this.$createElement("div", content),
      });
    },

    checkDisabledAndPrice(products) {
      let msg = "";
      let flag = false;
      let content = [];

      products.forEach((item) => {
        if (item.isEnabled === 0 && item.isTempPurchase === 0) {
          this.form.details.forEach((detail, index) => {
            if (detail.supplierProductId === item.id) {
              msg += `第${index + 1}行：${detail.supplierProductNo} 产品名称 [${detail.productName}] 规格型号 [${detail.specName}] <br/>`;
            }
          });
        }
      });

      if (msg) {
        msg += "已被禁用，请核对后再验收";
      }

      this.form.details.forEach((detail, index) => {
        products.forEach((item) => {
          if (detail.supplierProductId === item.id && detail.price !== item.purchasePrice) {
            content.push(this.$createElement("p", `第【${index + 1}】行产品的采购价【${detail.price}】与供应商产品目录里的采购价【${item.purchasePrice}】不一致;`));
            flag = true;
          }
        });
      });

      if (flag) {
        content.push(this.$createElement("p", { style: "color:red" }, `是否继续验收？`));
      }

      return { msg, flag, content };
    },

    showPriceConfirmationDialog(content) {
      this.$confirm("提示", {
        title: "提示",
        type: "warning",
        message: this.$createElement("div", content),
      }).then(() => this.save()).catch(() => this.$store.dispatch('SetLoading', false));
    },
    save () {     
      if(this.system_setting.IsUsePDA&&this.form.oneLevelWarehouseId){
       this.form.taskState = 0
      }else if(this.system_setting.IsUsePDA&&!this.form.oneLevelWarehouseId){
        this.form.taskState = 1
      }
      
      SavePurchaseDistribution(this.form).then((res) => {
        this.loading = false
        this.$my_message(`执行成功`, "success");
        sessionStorage.setItem("editMode", 0);
        // this.handleUpdate
        // this.$route.query.id
        let query = {}
        this.$store.dispatch('SetLoading',false)
        if(this.$route.query.formMode==3&&res.returnData.isMergedOrder==1){
          GetPurchaseDistributionById({
          id:this.form.id
        }).then(res=>{
          if(res.returnData.status ==2&&this.form.distribute==1){
            query.distributeId = this.form.id
          }
          this.routePushWithParams(
          this.getMainPath(this.$route.path),
          this.$route.params,
          query
        );
        })
        }else{
          this.$store.dispatch('SetLoading',false)
          this.routePushWithParams(
          this.getMainPath(this.$route.path),
          this.$route.params,
        );
        }
      
      }).catch(()=>{
          this.loading = false
      });
    },
    resetForm () {
      this.form = {
        supplierId: "",
        deliveryTime: new Date(),
        warehouseCategory: "1",
        warehouseId: "",
        totalNumber: 0,
        totalAmount: 0,
        supplierId: "",
        supplierName: "",
        oneLevelWarehouseId: "",
        oneLevelWarehouseName: "",
        orderNo: "",
        category: 0,
        remark: "",
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId'),
      };

        if(this.system_setting.IsUsePDA){
        this.form.shelfState = 0        
      }
     
    },
     // 上传附件
     filesChange (fileList) {
      this.form.fileInfos = fileList;
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(
        this.getMainPath(this.$route.path),
        this.$route.params
      );
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.isScan = false;
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.isScan = false;
      this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: "",
        productName: "",
        specName: "",
        manufacturerName: "",
        locationName: "",
        mainNo: "",
        traceNo: "",
        productId: "",
        specId: "",
        productRegistCertId: "",
        productRegistCertNo: "",
        onlineNo: "",
        unit: "",
        minUnit: "",
        packSpec: "",
        manufacturerId: "",
        locationId: "",
        manufactureDate: "",
        batch: "",
        validityDate: "",
        serialNo: "",
        number: 1,
        price: 0,
        amount: 0,
        remark: "",
      };
    },
    cancelChildDialog () {
      // console.log("qx")
      this.updateShowWarning()
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.updateShowWarning()
      this.pushChildForm(true);
      this.$nextTick(() => {
        // 查找弹出框的按钮行
        const dialogFooter = document.querySelector(".el-message-box__btns");
        if (dialogFooter) {
          // 检查是否已经存在 .custom-span
          const existingSpan = dialogFooter.querySelector(".custom-span");
          if (existingSpan) {
            // 如果已存在，则移除整个 span 元素，包括复选框
            dialogFooter.removeChild(existingSpan);
          }
        }
      });
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();

      this.getProductList("");
    },
    childNumberChange () {
      // if (!this.form.drmPurchaseDistributionNo) {
      //   this.childForm.distributionNumber = this.childForm.number
      // }
      this.autoAmount();
    },
    autoAmount () {
      if(this.childForm.billingLogo){
        this.childForm.billingPrice = this.childForm.price;
      }
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      // this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // scan

    openScanner (ev) {
      this.count = 0;
      this.resetDetailFormData();
      this.isScan = true;
      this.openSubformModal = true;
      ev.target.blur();
    },

    // change event
    supplierChange (val) {
      this.form.supplierId = val;
      this.form.supplierName = this.STATIC_Suppliers.filter(
        (item) => item.id == val
      )[0].name;
      // this.getProductList("");
      // this.getOrderList("");
      // this.form.orderNo = "";
      // this.form.orderId = "";
    },
    orderChange (row) {
      // var order = this.orderList.filter((e) => e.no == row);
      // console.log(val, "sssssssssssssss");
      
      this.form.orderNo = row.no;
      this.form.orderId = row.id;
      this.form.supplierId = row.supplierId;
      this.form.supplierName = row.supplierName;
      this.form.oneLevelWarehouseId = row.oneLevelWarehouseId;
      this.form.oneLevelWarehouseName = row.oneLevelWarehouseId;
      this.form.wardId = row.wardId
      this.form.showIsMergedOrder = Boolean(row.isMergedOrder)
      this.form.distribute =  this.form.showIsMergedOrder?1:0
      this.getProductList("", 1);
      this.oneLevelWarehouseChange(this.form.oneLevelWarehouseId);
    },
    certChange (val) {
      var cert = this.STATIC_ProductRegistCertDetails.find(
        (item) => item.productRegistCertId === val
      );
      if (cert) {
        this.childForm.productRegistCertId = val;
        this.childForm.productRegistCertNo = cert.no;
        this.childForm.productRegistCertName = cert.name;
        this.childForm.manufacturerId = cert.manufacturerId;
        this.childForm.manufacturerName = cert.manufacturerName;
      }
    },
    warehouseChange (val) {
      var ids = val.split(";");
      if (ids && ids.length > 0) {
        this.form.warehouseId = ids[0];
        let arr = this.warehouseList.filter(
          (item) => item.id == ids[0] && item.deptIds == ids[1]
        );
        this.form.warehouseName = arr[0].name + " " + arr[0].deptNames;
        this.form.deptId = arr[0].deptIds;
        this.form.warehouseCategory = arr[0].category;
      } else {
        this.form.warehouseId = "";
        this.form.warehouseName = "";
        this.form.deptId = "";
        this.form.warehouseCategory = "1";
      }
    },
    productChange (row) {
      let id = this.childForm.id;
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      this.childForm = Object.assign(this.childForm, row); // this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      this.childForm.id = id;
      this.childForm.supplierProductId = row.id;
      this.childForm.number = 1;
      this.childForm.price = this.childForm.purchasePrice;
      this.childForm.amount = this.childForm.price;
      this.childForm.supplierProductNo = this.childForm.no;
      this.childForm.remark = "";

      // console.log(this.childForm)
      this.getProductRegistCertDetails(this.childForm.productId);

      this.$refs.number.focus();
      this.$refs.number.select();

      this.$refs.childForm.validateField("productName");
    },
    oneLevelWarehouseChange (val) {
      this.form.oneLevelWarehouseId = val;
      let arr = this.STATIC_OneLevelWarehouses.filter((item) => item.id == val);
      this.form.oneLevelWarehouseManagerId = arr ? arr[0].managerId : "";
      this.form.oneLevelWarehouseAccepterIds = arr ? arr[0].accepters : "";
   
    },

    getProductList (keyWord, num) {
      var supplierId = 0;
      if (this.form.supplierId) {
        supplierId = this.form.supplierId;
      }
      let IsEnabledTempPurchaseGroup = num == 1 ? num : "";
      var orderId = "";
      if (this.form.orderId) {
        orderId = this.form.orderId;
      }

      this.getSupplierProducts(
        //query)
        {
          keyWord: keyWord,
          pageIndex: 1,
          pageSize: 100,
          supplierId: supplierId,
          orderId: orderId,
          isEnabled: 1,
          status: 2,
          IsEnabledTempPurchaseGroup: 1,
        }
      );
    },
    getWarehouseList (keyWord) {
      GetDeptWarehouses({
        keyWord: keyWord,
        state: 1,
      }).then((res) => {
        this.warehouseList = res.returnData;
      });
    },
    getOrderList (keyWord) {
      var supplierId = 0;
      if (this.form.supplierId) {
        supplierId = this.form.supplierId;
      }

      var query = {
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 100,
        // supplierId: supplierId,
        states: [1, 2, 3, 4, 5, 6],
        status: 2,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
      };
      GetPurchaseOrders(query).then((res) => {
        this.orderList = res.returnData.data;
      });
    },

    validateCheckNumber (rule, value, callback) {
      if (value) {
        // var distributionNumber = this.childForm.distributionNumber

        if (value > this.childForm.distributionNumber) {
          callback(new Error("验收数量不能大于配送数量"));
        }
        callback();
      }
    },
 

    updatePriceClose () {
      this.updatePriceDisable = false;
    },
    updatePriceSubmit () {
      this.updatePriceDisable = false;
      let obj = {}
      obj.details = JSON.parse(JSON.stringify(this.form.details))
      obj.warehouseId = this.form.warehouseId
      obj.warehouseName = this.form.warehouseName
      obj.deptId = this.form.deptId
      obj.warehouseCategory = this.form.warehouseCategory
      this.handleUpdate(this.form.id).then((res) => {
        this.form.result = 1;
        this.form.warehouseName = obj.warehouseName
        this.form.deptId = obj.deptId
        this.form.warehouseCategory = obj.warehouseCategory
        this.form.warehouseId = obj.warehouseId
        this.form.details = obj.details
        this.submit(true);
      });
    },

  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>

<style>
.el-message-box {
  width: 420px;
}

.el-message-box .el-message-box__content {
  max-height: 300px;
}

</style>
<style>
.promptBox {
  width: 800px !important;
  max-height: 300px;
}
</style>
